import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import BaseAdapter from "../base/BaseAdapter";
import { getDetailUrl, getShareMessage, urlFormatter, addQuery, getUrlParams, getDomain, getCookie, noConflict, loadJS, guid } from "../../core/utils";
var WubaAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(WubaAdapter, _BaseAdapter);
  var _super = _createSuper(WubaAdapter);
  function WubaAdapter(native) {
    var _this;
    _classCallCheck(this, WubaAdapter);
    return _this = _super.call(this, native, "//a.58cdn.com.cn/app58/rms/app/js/app_30805.js?__t=".concat(new Date().getTime()), function () {
      noConflict();
      _this.WBAPP = window.WBAPP;

      // 在load中执行sdk方法，58app在安卓下，可能会出现webview没ready导致执行失效的问题
      if (document.readyState === 'complete') {
        _this._init();
      } else {
        window.addEventListener('load', function () {
          _this._init();
        });
      }
    }, {
      disableAutoInit: true
    });
  }
  _createClass(WubaAdapter, [{
    key: "setTitle",
    value: function setTitle(obj) {
      setTimeout(function () {
        return window.WBAPP.action.setTitle(obj.title);
      }, 1000);
    }
  }, {
    key: "share",
    value: function share(shareMessage) {
      var _this2 = this;
      window.WBAPP.action.extendBtn([{
        key: 'share',
        txt: '分享',
        icon: 'share'
      }], 'wubaRightBtnCallback');
      window.wubaRightBtnCallback = function () {
        _this2.shareClick(shareMessage);
      };
    }
  }, {
    key: "shareClick",
    value: function shareClick(shareMessage) {
      var _getShareMessage = getShareMessage(shareMessage),
        title = _getShareMessage.title,
        shareUrl = _getShareMessage.shareUrl,
        imageUrl = _getShareMessage.imageUrl,
        desc = _getShareMessage.desc,
        type = _getShareMessage.type,
        data_url = _getShareMessage.data_url;
      window.WBAPP.extend.share.to('WEIXIN,FRIENDS,SINA,QQ', {
        url: shareUrl,
        title: title,
        content: desc,
        img_url: imageUrl,
        type: type || 'url',
        data_url: data_url || ''
      });
    }
  }, {
    key: "setRightBtn",
    value: function setRightBtn(obj) {
      var _this3 = this;
      var label = obj.label,
        url = obj.url,
        newPageTitle = obj.newPageTitle,
        icon = obj.icon;
      window.WBAPP.action.extendBtn([{
        key: 'default',
        txt: label,
        icon: icon || 'default'
      }], 'wubaDefineBtnCallback');
      window.wubaDefineBtnCallback = function () {
        _this3.skipToUrl({
          targetUrl: url,
          newPageTitle: newPageTitle
        });
      };
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail(obj) {
      var _this4 = this;
      var infoId = obj.infoId,
        _obj$metric = obj.metric,
        metric = _obj$metric === void 0 ? '' : _obj$metric,
        _obj$extraParam = obj.extraParam,
        extraParam = _obj$extraParam === void 0 ? {} : _obj$extraParam,
        _obj$needClose = obj.needClose,
        needClose = _obj$needClose === void 0 ? '0' : _obj$needClose;
      var extParam = '';
      try {
        extParam = encodeURIComponent(JSON.stringify(extraParam));
      } catch (error) {
        console.error('[adapter - skipToDetail] extraParam 参数解析异常');
      }
      var cbName = "get58CoodsDetailDataCb".concat(guid());
      obj.$customUrl = "https://m.zhuanzhuan.com/platform/zzmshare/index.html?isTrade=1&metric=".concat(metric, "&zzfrom=").concat(metric, "#/detail/").concat(infoId);
      var defaultUrl = getDetailUrl(obj);
      window[cbName] = function (data) {
        var respCode = data.respCode,
          respData = data.respData;
        if (respCode == 0 && respData.webUrl) {
          defaultUrl = respData.webUrl || defaultUrl;
        }
        _this4.agentSkipToDetail(obj, function () {
          _this4.skipToUrl({
            targetUrl: defaultUrl,
            needClose: needClose
          });
        });
      };
      loadJS("https://app.zhuanzhuan.com/zz/transfer/getgoodsdetaildataexclusive?infoId=".concat(infoId, "&callback=").concat(cbName, "&metric=").concat(metric, "&extraparam=").concat(extParam), function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "skipToUrl",
    value: function () {
      var _skipToUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj) {
        var targetUrl, newPageTitle, isfinish, needClose, _obj$extraParams, extraParams;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              targetUrl = obj.targetUrl, newPageTitle = obj.newPageTitle, isfinish = obj.isfinish, needClose = obj.needClose, _obj$extraParams = obj.extraParams, extraParams = _obj$extraParams === void 0 ? {} : _obj$extraParams;
              targetUrl = urlFormatter(targetUrl);
              window.WBAPP.invoke('pagetrans', {
                // this 暂时改成 window
                action: 'pagetrans',
                tradeline: 'core',
                content: _objectSpread({
                  pagetype: 'common',
                  loadingtype: 2,
                  title: newPageTitle,
                  url: targetUrl,
                  isfinish: !!isfinish || !!parseInt(needClose, 10) || false
                }, extraParams)
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function skipToUrl(_x) {
        return _skipToUrl.apply(this, arguments);
      }
      return skipToUrl;
    }()
  }, {
    key: "skipToOrder",
    value: function skipToOrder(obj) {
      var orderUrl = obj.orderUrl,
        metric = obj.metric,
        infoId = obj.infoId,
        title = obj.title;
      orderUrl = orderUrl || "".concat(getDomain(), "/trade/create-order/index.html?metric=").concat(metric, "&infoId=").concat(infoId, "#/home");
      this.skipToUrl(_objectSpread(_objectSpread({}, obj), {}, {
        targetUrl: orderUrl,
        newPageTitle: title || ''
      }));
    }
  }, {
    key: "getUid",
    value: function getUid() {
      var zzu = getCookie('ZZU');
      var uid = (/UID=(\d+)&/.exec(zzu) || [])[1];
      return +uid ? uid : '';
    }
  }, {
    key: "login",
    value: function login(params) {
      var cb = function cb() {};
      if (_typeof(params) === 'object') {
        cb = params.callback;
      } else {
        cb = params;
      }
      // 用户每次进入页面都会进行授权
      // 显示的传入url参数hasauth=1，如果页面URL中含有这个参数，就认定已经授权登录过，之后就不走授权了
      // 如果没有的话，那么就需要重新再次走一次授权，避免出现转转账号与58不一致情况
      if (getUrlParams().hasauth == '1') {
        cb && cb({
          code: '0'
        });
      } else {
        var targetUrl = ''; // 授权后跳转的目标url
        var url = ''; // 后端接口
        // 如果参数是对象，则对各个属性赋值
        if (_typeof(params) == 'object') targetUrl = params.targetUrl;
        targetUrl = addQuery(targetUrl || location.href, {
          __wuba: new Date().getTime(),
          hasauth: '1'
        });
        var loginFun = function loginFun() {
          var domain = /58\.com/.test(targetUrl) ? 'https://i.zhuanzhuan.com/bGNgt' : 'https://i.zhuanzhuan.com/bGNeg';
          var appKey = 'b15a8d7b5184d8935ce1b4965fbd0a46';
          url = "".concat(domain, "?rurl=").concat(encodeURIComponent(targetUrl));
          window.location.replace("https://openapi.58.com/v2/auth/app_show?app_key=".concat(appKey, "&scopes=1,7&redirect_authorize=true&redirect_uri=").concat(encodeURIComponent(url)));
        };
        window.WBAPP.invoke('is_login', function (state) {
          if (state == '0') {
            loginFun();
          } else {
            window.WBAPP.action.login(function (result) {
              if (result == '0') {
                loginFun();
              } else {
                cb && cb({
                  code: '-1'
                });
              }
            });
          }
        });
      }
    }
  }, {
    key: "isLoginAsync",
    value: function isLoginAsync(_ref) {
      var _this5 = this;
      var callback = _ref.callback;
      // 58端登录判断，需要满足如下3个条件
      // 第一：用户登录了58app
      // 第二：用户登录了转转
      // 第三：转转登录信息是通过58授权得来的
      window.WBAPP.invoke('is_login', function (state) {
        if (state == '0' && _this5.isLogin() && getCookie('isUnion') == '1') {
          callback && callback(true);
        } else {
          callback && callback(false);
        }
      });
    }
  }, {
    key: "isLogin",
    value: function isLogin() {
      // 简单通过ZZU判断是否登录了转转，不保证登录账号的是否授权
      return !!getCookie('ZZU');
    }
  }, {
    key: "close",
    value: function close(callback) {
      var useNative = true;
      if (_typeof(callback) === 'object') {
        useNative = callback.useNative;
        callback = callback.callback;
      }
      if (useNative) {
        window.WBAPP.action.goback(true);
      } else {
        window.history.go(-1);
      }
    }
  }, {
    key: "setPageBackAction",
    value: function setPageBackAction(callback) {
      window.WBAPP.invoke('device_event', {
        type: 'goback' // goback:页面回退时触发
      }, function () {
        callback.apply(void 0, arguments);
      });
    }
  }, {
    key: "registerPageCallback",
    value: function registerPageCallback(callback) {
      if (_typeof(callback) === 'object') {
        callback = callback.callback;
      }
      window.WBAPP.action.deviceEvent('pageshow', function () {
        callback && callback({
          code: '0',
          msg: '页面显示',
          pageState: '1',
          result: ''
        });
      });
    }
  }]);
  return WubaAdapter;
}(BaseAdapter);
_defineProperty(WubaAdapter, "pluginName", 'WubaAdapter');
_defineProperty(WubaAdapter, "platform", [{
  rule: /WUBA/,
  name: 'app58'
}]);
export { WubaAdapter as default };